<template>
    <main class="mt-3">
       

        <div 
            class="card mb-2 shadow-none border-left-lg " 
            v-for="(item, index) in $v.formulario.$each.$iter" 
            :key="item.id"
        >
            <div class="card-header bg-white py-3 d-flex align-items-center justify-content-between">
                <div class="text-gray-700 font-weight-bold mb-0 text-uppercase small tracking-wider">
                    <i class="fas fa-clipboard-list mr-2"></i>
                    {{ item.$model.nombre }}
                </div>
            </div>
            <div class="card-body bg-light">
                <div class="row">
                    <div 
                        class="col-12 mb-2" 
                        v-for="(pregunta, pIndex) in item.$model.preguntas" 
                        :key="`pregunta_${index}_${pIndex}`"
                    >
                        <div class="card border-0 shadow-none bg-white p-2 rounded shadow-sm h-100">
                            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                                <div class="font-weight-bold text-dark mb-2 mb-md-0 mr-3">
                                    {{ pregunta.nombre }}
                                </div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <div 
                                        class="custom-control custom-radio custom-control-inline mr-3"
                                        v-for="(opcion, oIndex) in pregunta.opciones"
                                        :key="`opcion_${index}_${pIndex}_${oIndex}`"
                                    >
                                        <input 
                                            type="radio" 
                                            :id="`radio_${index}_${pIndex}_${oIndex}`" 
                                            :name="`radio_group_${index}_${pIndex}`"
                                            class="custom-control-input"
                                            :value="opcion.texto"
                                            v-model="pregunta.respuesta"
                                        />
                                        <label 
                                            class="custom-control-label font-weight-500 text-black cursor-pointer" 
                                            :for="`radio_${index}_${pIndex}_${oIndex}`"
                                        >
                                            {{ opcion.texto }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div 
                                class="text-danger x-small mt-1" 
                                v-if="item.preguntas.$each[pIndex].respuesta.$error && item.preguntas.$each[pIndex].respuesta.$dirty"
                            >
                                <i class="fas fa-exclamation-circle mr-1"></i> Este campo es obligatorio
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Clasificación de Riesgo -->
        <div v-if="clasificacion" class="sticky-top mb-4" >
            <div class="card border-0 shadow-sm" :class="clasificacion.class">
                <div class="card-body py-3 d-flex align-items-center justify-content-between">
                    <div class="h5 mb-0 font-weight-bold">
                        <i class="fas fa-exclamation-triangle mr-2"></i>
                        CLASIFICACIÓN DE RIESGO: {{ clasificacion.text }}
                    </div>
                    <div class="small opacity-75 d-none d-md-block">
                        Basado en los criterios seleccionados
                    </div>
                </div>
            </div>
        </div>

        <div class="alert alert-danger-soft border-left-lg border-danger text-danger text-center small py-3 mb-4" v-if="$v.formulario.$error && $v.formulario.$dirty">
            <i class="fas fa-exclamation-triangle mr-2"></i> Por favor, complete todos los campos obligatorios del formulario antes de continuar.
        </div>
    </main>
</template>
<script>
import formulariosService from "../../../services/formulariosService";
import Toast from '../../../components/common/utilities/toast';
import respuestasFormulariosService from '../../../services/respuestasFormulariosService';
import {isEmpty} from "lodash";
import {required} from "vuelidate/lib/validators";
export default {
    props: ['idHistoria','finalizada','codigo','trimestre','usuario'],
    data() {
        return {
           formulario:{},
           id_formulario : '',         
        }
    },
    validations (){
        return {
            formulario : {
                $each : {
                    preguntas:{
                        $each : {
                            respuesta: {required}
                        }
                    }
                }
            },
        }
    },
    computed: {
        clasificacion() {
            if (!Array.isArray(this.formulario) || this.formulario.length === 0) return null;

            const hasSi = (seccionNombre) => {
                const seccion = this.formulario.find(s => 
                    s.nombre.toUpperCase().includes(seccionNombre.toUpperCase()) &&
                    (seccionNombre.toUpperCase() !== 'ALTO' || !s.nombre.toUpperCase().includes('MUY ALTO'))
                );
                if (!seccion) return false;
                return seccion.preguntas.some(p => p.respuesta.toUpperCase() === 'SI');
            };

            if (hasSi('MUY ALTO')) return { text: 'RIESGO MUY ALTO', class: 'bg-danger-soft text-dark' };
            if (hasSi('ALTO')) return { text: 'RIESGO ALTO', class: 'bg-orange-soft text-dark' };
            if (hasSi('MODERADO')) return { text: 'RIESGO MODERADO', class: 'bg-warning-soft text-dark' };
            if (hasSi('BAJO')) return { text: 'RIESGO BAJO', class: 'bg-success-soft text-white' };

            return { text: 'SIN RIESGO IDENTIFICADO', class: 'bg-success-soft text-white' };
        }
    },
    methods: {
        async cargarFormulario(){

            try {

                this.LoaderSpinnerShow();

                const response = await formulariosService.showByCode(this.codigo);
                this.id_formulario = response.data.id;

                let respuestas_formulario=await respuestasFormulariosService.showByRespuestableId(
                    {
                        id:this.idHistoria,
                        id_formulario:this.id_formulario,
                        trimestre:this.trimestre!==''?this.trimestre:'',
                    }
                );

                if (isEmpty(respuestas_formulario.data)&& this.usuario) {
                    const last_response = await respuestasFormulariosService.showLastByUser({
                        id_usuario: this.usuario,
                        id_formulario: this.id_formulario,
                        codigo_tipo_historia: 'EMB',
                        id_historia: this.idHistoria,
                    });

                    if (!isEmpty(last_response.data)) {
                        respuestas_formulario = last_response;
                    }
                }
                

                this.formulario=response.data.secciones.map(x=>{
                    
                    return {
                        id:x.id,
                        nombre:x.nombre,
                        preguntas:x.preguntas.map(y=>{
                            let respuesta='';
                            if(!isEmpty(respuestas_formulario.data)){
                                respuesta=respuestas_formulario.data.items.find(r=>r.id_pregunta===y.id)?.valor || y.defaultValue || ''
                            }
                            const tipoMap = {
                                'TEXTO': 'TEXT',
                                'OPCIONES': 'OPC',
                                'FECHA': 'DATE',
                                'NUMERO': 'NUM'
                            };

                            return {
                                id:y.id,
                                id_seccion:y.id_seccion,
                                nombre:y.nombre,
                                opciones:y.opciones,
                                tipo:tipoMap[y.tipo] || '',
                                respuesta:respuesta,
                            }
                        })
                    }
                });

                this.LoaderSpinnerHide();
            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
            
        },
        async save() {
            try{

                this.$v.$touch();

                if(this.$v.$invalid) return;

                let respuestas=[];
                
                this.formulario.forEach(x=>{

                    x.preguntas.reduce((t,c) => {
                        let opcion = c.opciones.find(opc=>opc.opcion===c.respuesta);
                        return opcion!==undefined?opcion.id:0;
                    },0); 

                    let respuestas_secciones=x.preguntas.map(y=>{
                        let opcion=y.opciones.find(opc=>opc.texto===y.respuesta);
                        return {
                            id_pregunta:y.id,
                            respuesta:y.respuesta,
                            id_opcion:opcion!==undefined?opcion.id:'',
                        }
                    })

                    respuestas.push(...respuestas_secciones);
                });

                let respuestas_historia={
                    id_historia: this.idHistoria,
                    id_formulario:this.id_formulario,
                    respuestas:respuestas,
                    trimestre:this.trimestre
                }

                console.log(respuestas_historia);
        
                this.LoaderSpinnerShow();
                
                await respuestasFormulariosService.store(respuestas_historia);
            
                this.LoaderSpinnerHide();

                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con exito'
                });
            }catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }  
        }, 
    },
    async created() {
        await this.cargarFormulario();
    },
    watch: {
        trimestre: async function (value) {
            if (value) {
                await this.cargarFormulario();
            }
        },
    },
};
</script>

<style scoped>

.cursor-pointer {
    cursor: pointer;
}
</style>